import React from 'react';
import ReusableButton from './ReusableButton';
import { TrashIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  confirmLabel?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ isOpen, onClose, onConfirm, title, message, confirmLabel }) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-20 backdrop-blur-sm">
      <div className="bg-white p-12 rounded-sm">
        <h2 className="text-lg font-medium mb-4">{title || t('common.confirmAction')}</h2>
        <p className="text-sm mb-4">{message || t('common.confirmActionMessage')}</p>

        <div className="flex justify-start">
          <ReusableButton
            onClick={onClose}
            icon={<XMarkIcon className="size-5" aria-hidden="true" />}
            label={t('common.cancel')}
          />

          <ReusableButton
            onClick={onConfirm}
            icon={<TrashIcon className="size-5" aria-hidden="true" />}
            label={confirmLabel || t('common.delete')}
            className="bg-red-600 hover:bg-red-500"
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
